<template>
  <div style="padding-left:10px;" class="grid-state-btn" :class="{'div-vertical':vertical}">
    <el-button no="saveState" size="mini" :class="{'btn-vertical':vertical}" type="primary" @click="saveState">
      {{ saveBtnStr }}
    </el-button>
    <el-button no="resetState" size="mini" :class="{'btn-vertical':vertical}" type="primary" @click="resetState">
      {{ resetBtnStr }}
    </el-button>
  </div>
</template>

<script>

import { savePersonQueryConfig } from '@/api/commonComponent'
import { getUserInfo } from '@/utils/auth'
export default {
  name: 'CargoGridStateBtn',
  props: {
    vertical: { type: Boolean, default: false },
    configModule: { type: String, required: true },
    saveBtn: { type: String, default: '' },
    resetBtn: { type: String, default: '' },
    gridParams: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      perConfig: {
        bDefault: true,
        configContent: '',
        configModule: this.configModule,
        configName: 'default',
        configType: 2, // 固定值，表格配置
        configBy: 0
      }
    }
  },
  computed: {
    saveBtnStr() {
      if (this.saveBtn) return this.saveBtn
      return this.$t('Message.SaveColumnStatus')
    },
    resetBtnStr() {
      if (this.resetBtn) return this.resetBtn
      return this.$t('Message.ResetColumnStatus')
    }
  },
  methods: {
    saveState() {
      const currentUserInfo = getUserInfo()
      const configName = `local_uiDoc_person_gridStatus_${currentUserInfo.tenantId}_${currentUserInfo.userId}_${this.configModule}`
      const configContent = JSON.stringify(this.gridParams.columnApi.getColumnState())
      savePersonQueryConfig({ ...this.perConfig, configName, configContent, configBy: currentUserInfo.userId }).then(res => {
        this.$message.success(this.$t('Message.SaveColumnStatusSuccess'))
      }).catch((err) => {
        this.$message.error(this.$t('Message.SaveColumnStatusFailed'))
      })
    },
    resetState() {
      // 从缓存中获取
      const currentUserInfo = getUserInfo()
      this.gridParams.columnApi.setColumnState(JSON.parse(localStorage.getItem(`local_uiDoc_init_gridStatus_${currentUserInfo.tenantId}_${currentUserInfo.userId}_${this.configModule}`)))
      this.$message.success(this.$t('Message.ResetColumnStatusSuccess'))
    }
  }
}
</script>

<style scoped lang="scss">
.grid-state-btn {
  display: inline-block;
  .el-button + .el-button {
    margin-left: 10px;
    margin-right: 0px;
    margin-bottom: 5px;
  }
  .div-vertical {
     padding-left: 0px!important;
     display: flex;flex-direction: column;justify-content: flex-start
   }
  .btn-vertical{
    margin-top: 5px!important;
    margin-left:0px!important;
  }
}

</style>
